import React from 'react';
import { connect } from 'react-redux';
import Tab from '../../../common/tab-timer';
import Const from './Const';
import TabContent from './tabContent/TabContent';
import {
  REDUCER_NAME,
  fetchAccumulation,
  fetchBreakout,
  fetchBreakoutMa,
  fetchBestInDownTrend,
  fetchMarketAnomaly,
  changeTabData,
  cancelFetchAccumulation,
  cancelFetchBreakout,
  cancelFetchBreakoutMa,
  cancelFetchBestInDownTrend,
  cancelFetchMarketAnomaly,
  changeSortState,
  mapSortState,
} from './reducer';

class TaStrategy extends React.Component {
  constructor(props) {
    super(props);
    const { changeTabData, subTab } = this.props;
    if (subTab) {
      changeTabData(subTab);
    }
  }

  componentDidMount() {
    const { currentTabData } = this.props;
    this.fetchData(currentTabData);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState, currentTabData } = this.props;
    const isSortStateChanged =
      sortState !== prevProps.sortState &&
      Const.fetchDataSortKeys.includes(Object.keys(sortState)[0]);
    if (isSortStateChanged) {
      this.fetchData(currentTabData);
    }
  }

  fetchData = currentTabData => {
    const {
      fetchAccumulation,
      fetchBreakout,
      fetchBreakoutMa,
      fetchBestInDownTrend,
      fetchMarketAnomaly,
    } = this.props;
    if (currentTabData === Const.tabs.accummulation) {
      fetchAccumulation();
    }
    if (currentTabData === Const.tabs.breakOut) {
      fetchBreakout();
    }
    if (currentTabData === Const.tabs.breakOutMa) {
      fetchBreakoutMa();
    }
    if (currentTabData === Const.tabs.bestInDowntrend) {
      fetchBestInDownTrend();
    }
    if (currentTabData === Const.tabs.marketAnomaly) {
      fetchMarketAnomaly();
    }
  };

  clearAllInterval = () => {
    const {
      cancelFetchAccumulation,
      cancelFetchBestInDownTrend,
      cancelFetchBreakout,
      cancelFetchBreakoutMa,
      cancelFetchMarketAnomaly,
    } = this.props;

    cancelFetchAccumulation();
    cancelFetchBestInDownTrend();
    cancelFetchBreakout();
    cancelFetchBreakoutMa();
    cancelFetchMarketAnomaly();
  };

  componentWillUnmount() {
    this.clearAllInterval();
  }

  changeTab = currentTab => {
    const { changeTabData } = this.props;
    changeTabData(currentTab);

    this.clearAllInterval();
    this.fetchData(currentTab);
  };

  onSort = sortState => {
    const { changeSortState, currentTabData } = this.props;
    if (!Object.keys(sortState).length) {
      changeSortState(mapSortState[currentTabData]);
      return;
    }
    changeSortState(sortState);
  };

  render() {
    const { currentTabData } = this.props;

    return (
      <div className="tab-pane active d-flex flex-fill flex-column h-auto">
        <div className="list-filter px-20 flex-shrink-0">
          <Tab
            currentTab={currentTabData}
            listTab="taStrategy.listTaStrategy"
            changeTab={this.changeTab}
          />
        </div>
        <TabContent onSort={this.onSort} currentTab={currentTabData} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentTabData: state[REDUCER_NAME].currentTabData,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  fetchAccumulation,
  fetchBreakout,
  fetchBreakoutMa,
  fetchBestInDownTrend,
  fetchMarketAnomaly,
  changeTabData,
  cancelFetchAccumulation,
  cancelFetchBreakout,
  cancelFetchBreakoutMa,
  cancelFetchBestInDownTrend,
  cancelFetchMarketAnomaly,
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TaStrategy);
